import { ChevronsDown, ChevronsUp } from "lucide-react";
import React from "react";

const stringSlip = (str: string, maxLength: number): string => {
  if (str.length <= maxLength) {
    return str;
  }
  return str.slice(0, maxLength) + "...";
};

const renderSortField = (
  sortBy: string,
  sortOrder: "asc" | "desc",
  setSortOrder: (field: "asc" | "desc") => void,
  setSortBy: (field: string) => void,
  field: string,
  label: string,
) => {
  const handleSort = () => {
    if (sortBy === field) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortBy(field);
      //setSortOrder("asc");
    }
  };

  return (
    <span
      className={`sort-action cursor-pointer ${sortBy == field ? "has-active" : ""}`}
      onClick={() => handleSort()}
      title={label}
    >
      {label}
      <span className="icon is-small ml-2 pt-4">
        {sortOrder === "asc" && sortBy === field ? (
          <ChevronsUp
            className={sortBy === field ? "animate-bounce" : "text-stone-400"}
          />
        ) : (
          <ChevronsDown
            className={sortBy === field ? "animate-bounce" : "text-stone-400"}
          />
        )}
      </span>
    </span>
  );
};

export { renderSortField, stringSlip };
